import React, { useEffect, useState } from "react";
import { Mail, Phone, RefreshCw } from "lucide-react";
import ApiURl from "../../controllers/Api";

export default function AdminContactMessages() {
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchMessages = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${ApiURl}getContactMessages.php`);
      const data = await response.json();
      setMessages(data?.success ? data.data || [] : []);
    } catch (error) {
      console.error("Error loading contact messages:", error);
      setMessages([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMessages();
  }, []);

  return (
    <main className="min-h-screen bg-[#f7f3ed] p-5 font-[kanit] lg:p-8">
      <div className="mx-auto max-w-6xl rounded-3xl border border-[#eadfd3] bg-white p-5 shadow-sm lg:p-7">
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.25em] text-[#b29063]">Contact</p>
            <h1 className="font-serif text-4xl text-[#2B0000]">Messages</h1>
          </div>
          <button onClick={fetchMessages} className="inline-flex items-center gap-2 rounded-xl border px-4 py-2 font-semibold text-[#2B0000]">
            <RefreshCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} />
            Refresh
          </button>
        </div>

        <div className="space-y-4">
          {messages.map((item) => (
            <article key={item.id} className="rounded-2xl border border-[#eadfd3] bg-[#fffaf5] p-5">
              <div className="flex flex-wrap items-start justify-between gap-3">
                <div>
                  <h2 className="font-serif text-2xl font-semibold text-[#2B0000]">{item.subject || "Contact Enquiry"}</h2>
                  <p className="mt-1 text-sm text-[#6f625f]">
                    {item.name} • {new Date(item.created_at).toLocaleString("en-IN")}
                  </p>
                </div>
                <div className="flex flex-wrap gap-2 text-sm">
                  <a href={`mailto:${item.email}`} className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1 text-[#2B0000]">
                    <Mail className="h-4 w-4" /> {item.email}
                  </a>
                  {item.phone && (
                    <a href={`tel:${item.phone}`} className="inline-flex items-center gap-1 rounded-full bg-white px-3 py-1 text-[#2B0000]">
                      <Phone className="h-4 w-4" /> {item.phone}
                    </a>
                  )}
                </div>
              </div>
              <p className="mt-4 whitespace-pre-wrap leading-7 text-[#3d302d]">{item.message}</p>
            </article>
          ))}

          {!loading && messages.length === 0 && (
            <p className="rounded-2xl border border-dashed border-[#d9c4b0] py-12 text-center text-[#6f625f]">
              No contact messages yet.
            </p>
          )}
        </div>
      </div>
    </main>
  );
}
